<div class="form-disparo-overlay">
  <div class="form-disparo-container">
    <button class="form-disparo-close"><mat-icon (click)="closeModalFireConfiguration()">close</mat-icon></button>
    <div class="form-disparo-header">
      <div class="form-disparo-tab" [ngClass]="{'active': stepForm === 0}" (click)="handleStepForm(0)">ARQUIVOS</div>
      <div class="form-disparo-tab" [ngClass]="{'active': stepForm === 1}" (click)="handleStepForm(1)"
        [ngClass]="{'disabled-div': !validFormStepOne()}">MENSAGENS</div>
      <div class="form-disparo-tab" [ngClass]="{'active': stepForm === 2}" (click)="handleStepForm(2)"
        [ngClass]="{'disabled-div': !validFormStepTwo()}">CUSTOMIZAÇÃO
      </div>

      <div class="form-disparo-tab" [ngClass]="{'active': stepForm === 3}" (click)="handleStepForm(3)"
        [ngClass]="{'disabled-div': !validFormStepThree()}">AGENDAMENTOS
      </div>
    </div>
    <div class="form-disparo-content">
      <!-- ARQUIVOS STEP 1-->
      <div class="form-disparo-step" [ngClass]="{'active': stepForm === 0}">
        <form [formGroup]="formWAMDCSV">
          <div class="form-disparo-row">
            <div class="form-disparo-group">
              <label for="nomeCampanha">Nome da campanha: *</label>
              <input type="text" id="nomeCampanha" placeholder="Nome da campanha" formControlName="nome" ngPattern="" />
            </div>
            <div class="form-disparo-group">
              <label for="pais">Selecione o País: *</label>
              <select id="pais" formControlName="country">
                <option *ngFor="let country of countrys" [value]="country.code" selected>{{country.name}}</option>
              </select>
            </div>
          </div>
          <div class="form-disparo-row">
            <div class="form-disparo-group">
              <label for="importarContatos">Importar contatos: *</label>
              <input type="file" id="importarContatos" accept=".csv" (change)="handleFileCsv($event)" />
              <small>OBS: Apenas arquivos CSV</small>
            </div>
            <div class="form-disparo-group">
              <label for="colunaTelefone">Coluna do Telefone: *</label>
              <select id="colunaTelefone" formControlName="colunaTelefone">
                <option *ngFor="let column of columns" [value]="column.value">{{column.column}}</option>

              </select>
            </div>
          </div>
          <div class="form-disparo-row">
            <div class="form-disparo-checkbox">
              <label for="ignorarLinha" class="line-agendamento">
                <input type="checkbox" id="ignorarLinha" formControlName="ignoreRow" />
                Ignorar primeira linha</label>
            </div>
            <div class="form-disparo-checkbox">
              <label for="adicionarCampoEXT" class="line-agendamento">
                <input type="checkbox" id="adicionarCampoEXT" formControlName="addExt" />
                Adicionar campo EXT</label>
            </div>

          </div>
          <div class="form-disparo-row">
            <div>

            </div>
            <div class="align-ext">
              <ng-container *ngIf="formWAMDCSV.get('addExt')?.value">
                <select (change)="alterHandleExt($event)">
                  <option value="normal">Normal</option>
                  <option value="referencia">Referencia</option>
                </select>
                <ng-container *ngIf="handleExt === 'normal'">
                  <input type="text" placeholder="Digite o valor de referencia" formControlName="extData" />
                </ng-container>
                <ng-container *ngIf="handleExt === 'referencia'">
                  <label>Selecione uma coluna:</label>
                  <select name="" id="" formControlName="extData">
                    <option *ngFor="let column of columns" [value]="column.value">{{column.column}}</option>
                  </select>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="form-disparo-row ">
            <label>Importar Imagem/Video/PDF/Audio:</label>
            <button type="button" *ngIf="countInputFile > 0 " class="form-disparo-remove-btn"
              (click)="handleRemoveInputFile()">
              <mat-icon>remove</mat-icon>
            </button>
            <button type="button" class="form-disparo-add-btn" (click)="handleAddInputFile()">
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <ng-container *ngIf="countInputFile > 0" class="align-inputs">
            <div class="align-inputs">
              <ng-container *ngIf="countInputFile > 0">
                <input type="file" class="input-file" (change)="onFilesSelected($event)"
                  accept=".pdf,.jpeg,.jpg,.png,.ogg,.opus,.mp4" />
                <small>
                  <p *ngIf="errorMessage" style="color: red;">{{ errorMessage }}</p>
                </small>
              </ng-container>

              <ng-container *ngIf="countInputFile > 1">
                <input type="file" class="input-file" (change)="onFilesSelected($event)"
                  accept=".pdf,.jpeg,.jpg,.png,.ogg,.mp4" />
                <small>
                  <p *ngIf="errorMessage" style="color: red;">{{ errorMessage }}</p>
                </small>

              </ng-container>

              <ng-container *ngIf="countInputFile > 2">
                <input type="file" class="input-file" (change)="onFilesSelected($event)"
                  accept=".pdf,.jpeg,.jpg,.png,.ogg,.mp4" />
                <small>
                  <p *ngIf="errorMessage" style="color: red;">{{ errorMessage }}</p>
                </small>

              </ng-container>
            </div>
          </ng-container>

          <div class="form-disparo-row form-disparo-actions">
            <button type="button" class="form-disparo-cancel" (click)="closeModalFireConfiguration()">CANCELAR</button>
            <button type="button" class="form-disparo-continue" (click)="handleContinue()"
              [disabled]="errorMessage || validFormStepOne() === false"
              [ngClass]="{'block-button': errorMessage || !validFormStepOne() }">CONTINUAR</button>
          </div>
        </form>
      </div>
      <!-- STEP 2 - MENSAGENS  -->
      <div class="form-disparo-step" [ngClass]="{'active': stepForm === 1}">
        <form [formGroup]="formWAMDCSV">
          <div class="form-disparo-row">
            <div class="form-disparo-group">
              <label for="nomeCampanha">Msg - Pre Definida:</label>
              <select (change)="handleAddTextMessage($event)">
                <option value="Selecione uma opcao" selected disabled></option>
                <option *ngFor="let message of listMessages" [value]="message.message">{{message.title}}</option>
              </select>
            </div>
            <div class="form-disparo-group">
              <label for="nomeCampanha">Referencia:</label>
              <select (change)="handleAddRefMessage($event)">
                <option selected></option>
                <option *ngFor="let referencia of columnRef" [value]="referencia.value">{{referencia.column}}</option>
              </select>
            </div>
          </div>
          <div class="form-disparo-row">
            <!-- <div class="form-disparo-group-message-form"> -->
            <!-- <textarea class="text-area-message" formControlName="mensagem"></textarea> -->
            <div class="textarea-container">
              <textarea class="mensagem-textarea" placeholder="Mensagem" formControlName="mensagem"></textarea>
              <button class="emoji-button" (click)="toggleEmojiPicker($event)">😊</button>
            </div>
            <emoji-mart *ngIf="isEmojiPickerVisible" (emojiClick)="addEmoji($event)"></emoji-mart>
          </div>
          <!-- </div> -->
          <div class="form-disparo-row form-disparo-actions" [style.margin-top]="'50px'">
            <button type="button" class="form-disparo-cancel" (click)="handleStepForm(stepForm - 1)">VOLTAR</button>
            <button type="button" class="form-disparo-continue" [disabled]="!validFormStepTwo()"
              [ngClass]="{'block-button': !validFormStepTwo()}"
              (click)="handleStepForm(stepForm + 1)">CONTINUAR</button>
          </div>

        </form>
      </div>
      <!-- DIV STEP 3 - CUSTOMIZACAO -->
      <div class="form-disparo-step" [ngClass]="{'active': stepForm === 2}">
        <form [formGroup]="formWAMDCSV">
          <div class="form-disparo-row">
            <div class="form-disparo-group">
              <label>Ordem de Envio:</label>
              <select formControlName="ordemenvio">
                <option value="0">Texto/Midia</option>
                <option value="1">Midia/Texto</option>
              </select>
            </div>
          </div>
          <div class="form-disparo-row">
            <div class="channels-container">
              <label for="channels">Canais que deseja disparar: *</label>
              <div class="channel" *ngFor="let canal of listChannels">
                <input type="checkbox" [value]="canal.idcanal" class="checkbox"
                  [disabled]="canal.status === 'Desconectado'" (change)="handleSelectChannel($event)">
                <label for="channel-1" class="channel-label">
                  <span class="channel-name">{{canal.nomefila}}</span>
                  <span class="status"
                    [ngClass]="{'connected': canal.status === 'Conectado', 'disconnected' : canal.status === 'Desconectado'}">{{canal.status}}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="form-disparo-row form-disparo-actions" [style.margin-top]="'50px'">
            <button type="button" class="form-disparo-cancel" (click)="handleStepForm(stepForm - 1)">VOLTAR</button>
            <button type="button" class="form-disparo-continue" (click)="handleStepForm(stepForm + 1)"
              [disabled]="!validFormStepThree()" [ngClass]="{'block-button': !validFormStepThree()}">CONTINUAR</button>
          </div>
        </form>

      </div>
      <!-- DIV STEP 4 - AGENDAMENTOS -->
      <div class="form-disparo-step" [ngClass]="{'active': stepForm === 3}">
        <form [formGroup]="formWAMDCSV">
          <div class="form-disparo-row">

            <div class="line-agendamento">
              <label class="line-agendamento">
                <input type="checkbox" (change)="handleIsScheduled($event)" />
                Agendar Envio
              </label>
              <input *ngIf="isScheduled" class="input-time" type="time" (change)="handleManualyTimeData($event)" />
              <input *ngIf="isScheduled" type="date" placeholder="DD/MM/YYYY" [ngModel]="formattedDate"
                class="input-date" (change)="handleManualyDateData($event)" [ngModelOptions]="{ standalone: true }" />
            </div>
          </div>
          <div class="form-disparo-row">
            <div class="line-agendamento">
              <label class="line-agendamento">
                <input type="checkbox" formControlName="hComercial" />
                Disparar somente em horario comercial (08:00 as 19:00)

              </label>
            </div>
          </div>
          <div class="form-disparo-row">
            <div class="line-agendamento">
              <label class="line-agendamento">
                <input type="checkbox" formControlName="antiSpam" />
                Sistema Anti-Spam (Codigo Final da Mensagem)
              </label>
            </div>
          </div>
          <div class="form-disparo-row">
            <div class="line-agendamento">
              <label class="line-agendamento">
                <input type="checkbox" formControlName="sunday" />
                Disparar aos Domingos
              </label>
            </div>
          </div>
          <div class="form-disparo-row">
            <div class="line-agendamento">
              <label class="line-agendamento">
                <input type="checkbox" formControlName="saturday" />
                Disparar aos Sabados
              </label>
            </div>
          </div>
          <div class="form-disparo-row">
            <div class="line-agendamento">
              <label class="line-agendamento">
                <input type="checkbox" id="" [(ngModel)]="acceptTerm" [ngModelOptions]="{standalone: true}" />
                Concordo com os Termos do <a href="https://www.whatsapp.com/legal/terms-of-service?lang=pt_BR" target="_blank">Whatsapp
                  <strong style="color: red;">*</strong></a>
              </label>
            </div>
          </div>

          <div class="form-disparo-row form-disparo-actions" [style.margin-top]="'50px'">
            <button type="button" class="form-disparo-cancel" (click)="handleStepForm(stepForm - 1)">VOLTAR</button>
            <button type="button" class="form-disparo-continue" (click)="handleSubmit()" [disabled]="!validCheckTerm()"
              [ngClass]="{'block-button': !validCheckTerm()}">ENVIAR</button>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>
<app-alert></app-alert>
<app-loading-modal></app-loading-modal>